import { getAttrsAsInVue2 } from '@ga/utils'

import { useImage } from './use'

// @vue/component
export default {
  name: 'ga-image',

  props: {
    className: {
      type: String,
      default: null,
    },
    src: {
      type: String,
      required: true,
    },
    sources: {
      type: Array,
      default: () => [],
    },
    lazy: {
      type: Boolean,
      default: true,
    },
  },

  setup(props, context) {
    return {
      ...useImage(props, context),
      getAttrsAsInVue2,
    }
  },
}
